export default __webpack_public_path__ + "static/media/wi-smoke.27d773ea.svg";